import { FormattedMessage } from "react-intl";
import { useInView } from "react-intersection-observer";

export const Steps = ({
	stepTitleKey,
	stepDescOneKey,
	stepDescTwoKey,
	number,
}) => {
	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold: 0.1,
	});

	// Formatear número con cero adelante (01, 02, 03)
	const formattedNumber = number.toString().padStart(2, '0');

	return (
		<div
			ref={ref}
			className={`
				transform transition-all duration-700 ease-out
				${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
			`}
			style={{ transitionDelay: `${(number - 1) * 150}ms` }}
		>
			<div className="group relative h-full">
				{/* Card */}
				<div className="relative bg-white rounded-2xl border border-surface-200 p-6 md:p-8 h-full hover:border-accent/40 hover:shadow-elevated hover:-translate-y-2 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
					{/* Large Number */}
					<div className="text-display-xl md:text-display-2xl font-bold text-accent/20 group-hover:text-accent/30 transition-colors mb-2">
						{formattedNumber}
					</div>

					{/* Content */}
					<h3 className="text-body-lg md:text-body-xl font-bold text-primary mb-3 group-hover:text-accent transition-colors">
						<FormattedMessage id={stepTitleKey} />
					</h3>

					<p className="text-body-md text-surface-600 leading-relaxed">
						<FormattedMessage id={stepDescOneKey} />
					</p>

					{stepDescTwoKey && (
						<p className="text-body-sm text-surface-500 mt-2">
							<FormattedMessage id={stepDescTwoKey} />
						</p>
					)}

					{/* Bottom accent line */}
					<div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-accent to-accent-light rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
				</div>

			</div>
		</div>
	);
};
